import scrollToElement from 'scroll-to-element';
import Axios from 'core/axios';
import Rest from 'core/rest';
import Validation from 'core/validation';
import { i18n } from 'core/i18n';
import {
	openMask, closeMask, openError
} from '../mainModule/action';

export const MANAGE_SEARCH_SUCCESS = 'MANAGE_SEARCH_SUCCESS';
export const MANAGE_SEARCH_SUCCESS_ERRORS = 'MANAGE_SEARCH_SUCCESS_ERRORS';
export const MANAGE_GET_AGENT_SUCCESS = 'MANAGE_GET_AGENT_SUCCESS';
export const MANAGE_PUT_AGENT_SUCCESS = 'MANAGE_PUT_AGENT_SUCCESS';
export const MANAGE_UPDATE_AGENT_INFO = 'MANAGE_UPDATE_AGENT_INFO';
export const MANAGE_CLEAR_AGENT_INFO = 'MANAGE_CLEAR_AGENT_INFO';
export const MANAGE_CLEAR_AGENT_LIST = 'MANAGE_CLEAR_AGENT_LIST';
export const MANAGE_POST_ERROR = 'MANAGE_POST_ERROR';
export const MANAGE_CLEAR_ERROR = 'MANAGE_CLEAR_ERROR';

export const search = (data)=>{
	return (dispatch) => {
		dispatch(openMask());
		Axios.post(Rest.agent.postAgent(), data)
			.then((response) => {
				dispatch(closeMask());
				dispatch({
					type: MANAGE_SEARCH_SUCCESS,
					data: response
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
};

export const searchAll = ()=>{
	return (dispatch) => {
		dispatch(openMask());
		Axios.post(Rest.agent.postAgent(), {})
			.then((response) => {
				dispatch(closeMask());
				dispatch({
					type: MANAGE_SEARCH_SUCCESS,
					data: response
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
};

export function getAgent(agentId) {
  return (dispatch) => {
		dispatch(openMask());
		return Axios.get(Rest.agent.getAgent(agentId))
			.then(async(response) => {
				const { data = {} } = response;
				await dispatch({
					type: MANAGE_GET_AGENT_SUCCESS,
					data,
					agentId
				});
				return dispatch(closeMask());
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
  };
}

export function putAgent(agentId, data, lockAgent = false) {
	return (dispatch) => {
		// 清空所有錯誤
		dispatch({
			type: MANAGE_CLEAR_ERROR
		});

		// 欄位驗證
		const errors = Validation.validateAgentInfo(data);
			
		// confirm check (email)
		if (data && data.confirmEmail !== data.email) {
			errors.confirmEmail = i18n('error_confirm_email');
		}
		// confirm check (password)，有修改密碼才需檢核
		if (data && data.hasOwnProperty('password') && data.confirmPassword !== data.password) {
			errors.confirmPassword = i18n('error_confirm_password');
		}

		if (errors && JSON.stringify(errors) !== '{}') {
			// 視窗滾動至最上方錯誤欄位
			let scrollTo = null;
			if (errors.agentStatus || errors.agentType) {
				// 滾動至登入資訊區塊
				scrollTo = 'login';
			} else if (errors.preferredLanguage) {
				// 滾動至設定區塊
				scrollTo = 'setting';
			} else if (errors.title || errors.firstName || errors.lastName
				|| errors.mobilePhone || errors.workPhone || errors.email || errors.confirmEmail) {
				// 滾動至聯絡人詳細資訊區塊
				scrollTo = 'contact';
			} else if (errors.address1 || errors.city || errors.addressState || errors.country) {
				// 滾動至地址區塊
				scrollTo = 'address';
			}
			
			if (scrollTo) {
				scrollToElement(`.manage-edit-panel.${scrollTo}`, {
					offset: -100,
					ease: 'out-circ',
					duration: 1500
				});
			}
				
			// 驗證失敗，顯示錯誤
			return dispatch({
				type: MANAGE_POST_ERROR,
				errors
			});
		} else {
			// 驗證成功，打API
			dispatch(openMask());
			
			let requestData = JSON.parse(JSON.stringify(data));
			
			// 拔除多餘key
			if (requestData.confirmEmail) delete requestData.confirmEmail;
			if (requestData.confirmPassword) delete requestData.confirmPassword;

			// 若電話第一碼為0，需拔除第一碼0
			if (requestData.mobilePhone && requestData.mobilePhone.number) {
				requestData.mobilePhone.number = (requestData.mobilePhone.number).replace(/^([0]*)([1-9]+[0-9]+)$/, '$2');
			}
			if (requestData.workPhone && requestData.workPhone.number) {
				requestData.workPhone.number = (requestData.workPhone.number).replace(/^([0]*)([1-9]+[0-9]+)$/, '$2');
			}

			// lockAgent = true，需一併更新封鎖or取消封鎖此人
			if (lockAgent) {
				requestData.lock = !requestData.lock;
			}
			
			return Axios.put(Rest.agent.putAgent(agentId), requestData)
				.then(() => {
					dispatch(closeMask());
					return dispatch({
						type: MANAGE_PUT_AGENT_SUCCESS
					});
				})
				.catch((error) => {
					dispatch(closeMask());
					return dispatch(openError(error));
				});
		}
  };
}

export function updateAgentInfo(data) {
	return (dispatch) => {
		dispatch({
			type: MANAGE_UPDATE_AGENT_INFO,
			data
		});
	};
}

export function clearAgentInfo() {
	return (dispatch) => {
		dispatch({
			type: MANAGE_CLEAR_AGENT_INFO
		});
	};
}

export const clearAgentList = () => {
	return (dispatch) => {
		dispatch({
			type: MANAGE_CLEAR_AGENT_LIST,
		});
	};
};